<template>
  <basic-container>
    <div class="event-entry-page">
      <el-form
        ref="form"
        v-loading="submitLoading"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        class="entry-form"
      >
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="事件标题" prop="eventName">
              <el-input v-model="form.eventName" maxlength="50" show-word-limit placeholder="请输入50字以内事件标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事件类型" prop="eventType">
              <el-select v-model="form.eventType" placeholder="请选择事件类型" style="width: 100%">
                <el-option v-for="item in eventTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级" prop="urgencyLevel">
              <el-select v-model="form.urgencyLevel" placeholder="请选择优先级" style="width: 100%">
                <el-option v-for="item in urgencyOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发生时间" prop="occurTime">
              <el-date-picker
                v-model="form.occurTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择发生时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="发生位置" prop="location">
              <el-input v-model="form.location" maxlength="200" show-word-limit placeholder="请输入事件发生位置" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传图片">
              <el-upload
                class="site-photo-upload"
                :class="{ 'upload-hidden': photoFiles.length >= uploadLimit }"
                :action="uploadAction"
                :headers="uploadHeaders"
                :file-list="photoFiles"
                :limit="uploadLimit"
                list-type="picture-card"
                accept="image/*"
                :before-upload="beforePhotoUpload"
                :on-success="handlePhotoSuccess"
                :on-remove="handlePhotoRemove"
                :on-preview="handlePhotoPreview"
                :on-exceed="handlePhotoExceed"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="form-tip">支持 jpg、png、jpeg 等图片格式，最多上传9张。</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理方式">
              <el-input
                v-model="form.handlingMethod"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入初步处理方式"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="事件描述">
              <el-input
                v-model="form.eventDescription"
                type="textarea"
                :rows="4"
                maxlength="1000"
                show-word-limit
                placeholder="请输入事件补充说明"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="form-actions">
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button type="primary" icon="el-icon-check" :loading="submitLoading" @click="handleSubmit">提交</el-button>
        </el-form-item>
      </el-form>

      <el-dialog title="提交成功" :visible.sync="resultVisible" width="560px" append-to-body>
        <div class="detail-grid">
          <div class="detail-item"><span>事件ID</span><strong>{{ result.eventId || '-' }}</strong></div>
          <div class="detail-item"><span>事件状态</span><strong>已提交</strong></div>
          <div class="detail-item wide"><span>事件标题</span><strong>{{ result.eventName || '-' }}</strong></div>
          <div class="detail-item wide"><span>发生时间</span><strong>{{ result.occurTime || '-' }}</strong></div>
        </div>
        <span slot="footer">
          <el-button size="small" @click="continueEntry">继续录入</el-button>
          <el-button size="small" type="primary" @click="goEventManage">查看应急事件管理</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="previewVisible" append-to-body width="720px">
        <img :src="previewUrl" class="preview-image" alt="">
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
import { report } from './api'
import { getToken } from '@/util/auth'
import website from '@/config/website'

const eventTypeOptions = [
  { label: '设备故障', value: 1 },
  { label: '自然灾害', value: 2 },
  { label: '人为事故', value: 3 }
]

const urgencyOptions = [
  { label: '特别重大', value: 1 },
  { label: '重大', value: 2 },
  { label: '较大', value: 3 },
  { label: '一般', value: 4 }
]

export default {
  name: 'EmergencyEventEntry',
  data () {
    return {
      form: this.defaultForm(),
      rules: {
        eventName: [
          { required: true, message: '请输入事件标题', trigger: 'blur' },
          { max: 50, message: '事件标题不能超过50字', trigger: 'blur' }
        ],
        eventType: [{ required: true, message: '请选择事件类型', trigger: 'change' }],
        urgencyLevel: [{ required: true, message: '请选择优先级', trigger: 'change' }],
        occurTime: [{ required: true, message: '请选择发生时间', trigger: 'change' }],
        location: [
          { required: true, message: '请输入发生位置', trigger: 'blur' },
          { max: 200, message: '发生位置不能超过200字', trigger: 'blur' }
        ]
      },
      eventTypeOptions,
      urgencyOptions,
      submitLoading: false,
      photoFiles: [],
      uploadLimit: 9,
      previewVisible: false,
      previewUrl: '',
      resultVisible: false,
      result: {}
    }
  },
  computed: {
    uploadAction () {
      return '/api/blade-resource/oss/endpoint/put-file-attach'
    },
    uploadHeaders () {
      const token = getToken()
      if (!token) return {}
      const bearer = 'Bearer ' + token
      return {
        Authorization: bearer,
        [website.tokenHeader]: bearer
      }
    }
  },
  methods: {
    defaultForm () {
      return {
        eventName: '',
        eventType: 1,
        urgencyLevel: 4,
        occurTime: '',
        location: '',
        sitePhoto: '',
        handlingMethod: '',
        eventDescription: '',
        triggerSource: 'manual'
      }
    },
    handleReset () {
      this.form = this.defaultForm()
      this.photoFiles = []
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.form,
          sitePhoto: this.photoFiles.map(item => item.url).filter(Boolean).join(',')
        }
        report(payload).then(({ data }) => {
          if (data.code === 200) {
            this.result = {
              eventId: data.data,
              eventName: payload.eventName,
              occurTime: payload.occurTime
            }
            this.resultVisible = true
            this.$message.success(data.msg || '提交成功')
          } else {
            this.$message.error(data.msg || '提交失败')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    continueEntry () {
      this.resultVisible = false
      this.handleReset()
    },
    goEventManage () {
      this.resultVisible = false
      this.$router.push({ path: '/contingency-management/y-event-manage/index' })
    },
    beforePhotoUpload (file) {
      const isImage = file.type && file.type.indexOf('image/') === 0
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.warning('请上传图片文件')
      }
      if (!isLt10M) {
        this.$message.warning('单张图片不能超过10MB')
      }
      return isImage && isLt10M
    },
    handlePhotoSuccess (res, file, fileList) {
      const url = this.resolveUploadUrl(res)
      if (url) {
        file.url = url
      }
      this.syncPhotoFiles(fileList)
    },
    handlePhotoRemove (file, fileList) {
      this.syncPhotoFiles(fileList)
    },
    handlePhotoPreview (file) {
      this.previewUrl = file.url || this.resolveUploadUrl(file.response)
      this.previewVisible = !!this.previewUrl
    },
    handlePhotoExceed () {
      this.$message.warning(`最多上传${this.uploadLimit}张图片`)
    },
    syncPhotoFiles (fileList) {
      this.photoFiles = fileList.map(item => ({
        ...item,
        url: item.url || this.resolveUploadUrl(item.response)
      })).filter(item => item.url)
      this.form.sitePhoto = this.photoFiles.map(item => item.url).join(',')
    },
    resolveUploadUrl (res) {
      if (!res) return ''
      const data = res.data || {}
      return data.link || data.url || data.fileUrl || data.fullLink || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.event-entry-page {
  .entry-form {
    max-width: 980px;
  }

  .form-tip {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
  }

  .form-actions {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }

  .site-photo-upload ::v-deep .el-upload--picture-card,
  .site-photo-upload ::v-deep .el-upload-list__item {
    width: 96px;
    height: 96px;
    line-height: 96px;
  }

  .upload-hidden ::v-deep .el-upload--picture-card {
    display: none;
  }

  .preview-image {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}
.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  span {
    flex: 0 0 90px;
    padding: 10px;
    color: #606266;
    background: #f5f7fa;
  }
  strong {
    flex: 1;
    padding: 10px;
    font-weight: 400;
    word-break: break-all;
  }
}
.detail-item.wide {
  grid-column: span 2;
}
</style>
